<template>
  <!--分组管理-->
  <div id="mainDateContain">
    <div>
      <div class="allSearch">
        <div class="newSearch d_flex">
          <!-- <div>
            <p>
              <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="分组名称" v-model="postData.filterName">
            </p> -->
            <p>
            <!--<select  class="allSelect" v-model="postData.depart">-->
            <!--<option value="" selected>请选择部门</option>-->
            <!--</select>-->
            <!--</p>-->
            <!-- <p>
              <button class="redButton" @click="selectMainDate">
                <i class="icon iconfont iconsousuo"></i>
                搜索
              </button>
            </p>
          </div> -->
          <div style="width: auto">
            <!-- <button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('AppOwner') >= 0 || isSystemAdmin === 'true'">添加</button> -->
            <button class="redButton m_r_10" @click="addNewSend ()">新建推送</button>
          </div>
        </div>
      </div>
      <div class="allTablePlace">
        <div>
          <!-- <nav class="t_r m_b_10"><button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('ContentEditor') >= 0">添加</button></nav> -->
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>ID</th>
              <th>推送类别</th>
              <!-- <th class="t_c">分组人数</th> -->
              <th class="t_c">推送时间</th>
              <!-- <th>组管理员</th> -->
              <th>推送人</th>
              <th>状态</th>
              <!-- <th>描述</th> -->
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td>{{item.name}}</td>
              <!-- <td>{{item.type}}</td> -->
              <td class="t_c">{{item.memberCount}}</td>
              <td :title="item.admins" class="NoWrap" style="max-width: 200px">{{item.admins}}</td>
              <td>{{item.creationTime.split('T')[0]}}</td>
              <!-- <td :title="item.description" width="15%" style="max-width: 300px;;padding-right: 10px" class="NoWrap">{{item.description}}</td> -->
              <td width="10%"><div class="icon more iconfont icongengduo moreOperations">
                <!-- <ul>
                  <li @click="getDominList(1, item)">查看成员</li>
                  <li v-if="(isSystemAdmin === 'true' || nowApp.roles.indexOf('GroupOwner') >= 0 || nowApp.roles.indexOf('AppOwner') >= 0) " @click="editGroup(item.id, item.type)">编辑</li>
                  <li v-if="item.type !== 'Default' && (isSystemAdmin === 'true' || nowApp.roles.indexOf('AppOwner') >= 0) " @click="removeGroup(item.id)">移除</li>
                  <li @click="exportGroup(item.id, item.name)">导出</li>
                </ul> -->
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="totalPage !== 0" v-on:on-getList="getList($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
      </div>
    </div>

            <sendPicker v-model="showSendPicker"></sendPicker>

  </div>
</template>

<script>
export default {
  name: 'mainDateList',
  data () {
    return {
      baseUrl: process.env.config.baseUrl,
      dominUserList: [],
      showSendPicker: false,
      dominUserModel: false,
      allPageDto: {
        allDominListTotalPage: 0,
        allDominListTotalCount: 0,
        allDominListPage: 1
      },
      OpenModel: false,
      showModel: false,
      title: '',
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        filterName: '',
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      newDominList: {
        name: '',
        email: '',
        org_Acronym: '',
        domninId: 0,
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin')
    }
  },
  created () {
    this.getList(1)
  },
  methods: {
    clearModel () {
      this.postData = {
        ID: '',
        title: '',
        ContentTypeIds: '',
        startdate: '',
        enddate: '',
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      }
    },
    // 查看成员
    getDominList (pageIndex, object) {
      if (object) {
        this.dominUserModel = true
        this.newDominList.domninId = object.id
      }
      this.allPageDto.allDominListPage = pageIndex
      this.newDominList.pageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/Group/' + this.newDominList.domninId + '/Members', this.newDominList)
      this.$axiox.get(url).then(msg => {
        this.dominUserList = msg.result.items
        this.allPageDto.allDominListTotalPage = Math.ceil(msg.result.totalCount / this.newDominList.pageSize)
        this.allPageDto.allDominListTotalCount = msg.result.totalCount
      })
    },
    addNewSend () {
      this.showSendPicker = true
    },
    // 新建
    editToUrl () {
      this.$router.push({
        name: 'editMainDateList'
        // params: {
        //   id: 0
        // }
      })
    },
    getList (pageIndex) {
      this.postData.pageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/Group/group', this.postData)
      this.$axiox.get(url).then(msg => {
        this.page = pageIndex
        this.myList = msg.result.items
        this.totalPage = Math.ceil(msg.result.totalCount / this.postData.pageSize)
        this.totalCount = msg.result.totalCount
      })
    },
    editGroup (id, type) {
      this.$router.push({
        name: 'editMainDateList',
        params: {
          id: id
        },
        query: {
          type: type
        }
      })
    },
    selectMainDate () {
      this.getList(1)
    },
    removeGroup (id) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此分组？',
        successFun: msg => {
          this.$axiox.del('/api/Group?Id=' + id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    exportGroup (id, name) {
      var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      xmlResquest.open('GET', this.baseUrl + '/api/Group/' + id + '/export?groupName=' + encodeURIComponent(name), true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('token'))
      xmlResquest.setRequestHeader('AppId', window.sessionStorage.getItem('AppId'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = name + '.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      // this.$axiox.get('/api/Group/' + id + '/export?groupName=' + name).then(msg => {
      // })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
      this.dominUserModel = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/mainDateContain.vue